import React, { useEffect, useState } from "react";
// import "../homePage/Components/Content.css";
import { FaRupeeSign } from "react-icons/fa";
import { useSelector, useDispatch, connect } from "react-redux";
import { Link } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
// import Loader from "../components/Loader/Loader.js";
import Loader from "../../components/Loader/Loader";
// import cart_gray from "../../Assets/cart_gray.svg";
import cart_empty from "../../Assets/cart_empty.svg";
import cart_fill from "../../Assets/cart_fill.svg";
import { Modal } from "react-responsive-modal";
import AddressPopUp from "./AddressPopUp";
import {
  AddtoCart,
  deleteCart,
  getCartDetails,
  getPackageDetails,
  setCity,
} from "../../Redux/Actions";
import { useHistory, useLocation } from "react-router-dom";
import { GET_CART_REQUEST, GET_CART_SUCCESS } from "../../Redux/Constants";

// for the notifications
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-toastify/dist/ReactToastify.minimal.css";
import FooterForm from "../Footer/FooterForm";

//PACKAGE DATA
const packageData = [
  {
    id: 1,
    title: "Fever Panel (CBC, Malaria Antigen, SGPT, WIDAL, Urine R/M)",

    listDesc: [
      "Total no.of Tests - 42",
      "Quick Turn Around Time",
      "Reporting as per NABL ISO guidelines",
    ],
    mrp: "1740",
    offerprice: "650",
    isPremium: false,
    rightTitle: "Economical Plan",
  },
  {
    id: 2,
    title: "Smart Full Body Checkup",
    rightTitle: "Most Popular Plan",
    listDesc: [
      "Total no.of Tests - 80",
      "Quick Turn Around Time",
      "Reporting as per NABL ISO guidelines",
    ],
    mrp: "₹1499",
    offerprice: "₹699",
    isPremium: true,
  },
  {
    id: 3,
    title: "Covid - 19 RTPCR Test",

    listDesc: [
      "Total no.of Test - 1",
      "Quick Turn Around Time",
      "Reporting as per NABL ISO guidelines",
    ],
    mrp: "₹1999",
    offerprice: "₹700",
    isPremium: false,
    rightTitle: "Economical Plan",
  },
  {
    id: 4,
    title: "Fever Panel (CBC, Malaria Antigen, SGPT, WIDAL, Urine R/M)",

    listDesc: [
      "Total no.of Tests - 42",
      "Quick Turn Around Time",
      "Reporting as per NABL ISO guidelines",
    ],
    mrp: "1740",
    offerprice: "650",
    isPremium: false,
    rightTitle: "Economical Plan",
  },
  {
    id: 5,
    title: "Smart Full Body Checkup",
    rightTitle: "Most Popular Plan",
    listDesc: [
      "Total no.of Tests - 80",
      "Quick Turn Around Time",
      "Reporting as per NABL ISO guidelines",
    ],
    mrp: "₹1499",
    offerprice: "₹699",
    isPremium: true,
  },
  {
    id: 6,
    title: "Covid - 19 RTPCR Test",

    listDesc: [
      "Total no.of Test - 1",
      "Quick Turn Around Time",
      "Reporting as per NABL ISO guidelines",
    ],
    mrp: "₹1999",
    offerprice: "₹700",
    isPremium: false,
    rightTitle: "Economical Plan",
  },
];

function OurImagingPackages(props) {
  const { values } = props;
  console.log("PROPSI", props);
  const [pack, setPack] = useState([]);
  const packageList = useSelector((state) => state.packageList);

  const history = useHistory();
  const location = useLocation();

  const pathname = location.pathname;

  //city List
  const navCity = useSelector((state) => state.navCityList);
  const { navCities, navloading } = navCity;

  const [ItemInCart, setItemInCart] = useState([]);
  const [cartisempty, setcartisempty] = useState(true);

  const { loading, packages } = packageList;
  const { results } = packages;
  console.log("card dta in component", values);

  const [openCartt, setOpenCartt] = useState(false);
  const onCloseModalCartt = () => setOpenCartt(false);

  const dispatch = useDispatch();
  const cartStatus = useSelector((state) => state.addToCartReducer);

  const CartItems = useSelector((state) => state.CartReducer);
  // const {loading} = cartStatus;

  // const deleteCart = useSelector((state) => state.deleteCart)
  // console.log("DELETE", deleteCart)

  // const itemIdArray = () => {
  //   console.log("clicked");
  //   let cartItemArray = [];
  //   if (CartItems.cartDetails) {
  //     CartItems.cartDetails[0].product.map((item) => {
  //       // console.log("here is item", CartItems);
  //       cartItemArray.push(item.package.id);
  //       // ItemInCart.push(item.package.id);
  //     });
  //     //get unique values for cart items
  //     // const uniqueArray = cartItemArray.filter((item, index) => {
  //     //   return cartItemArray.indexOf(item) === index; //returns unique values
  //     // });
  //     // console.log("uniqueArray", uniqueArray);
  //     setItemInCart(cartItemArray);
  //   }
  // };
  const [searchCity, setSearchCity] = useState("");
  const [display, setDisplay] = useState(true);

  const handelCity = (city) => {
    const userProfile = JSON.parse(localStorage.getItem("user"));
    localStorage.setItem("city", city);
    setSearchCity(city);
    dispatch(setCity(city != "" ? city : ""));
    setDisplay(false);
    // e.target.blur();
    // userProfile && userProfile !== ""
    //   ? dispatch(EmptyCart(userProfile && userProfile.token, successCd))
    //   : null;
  };

  const citySelected = useSelector((state) => state.cityOnTopNav);
  console.log("city is", citySelected?.citySelect);
  const { loading: loadingCity, citySelect } = citySelected;

  const successCb = () => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal && userFromLocal.token;
    dispatch(getCartDetails(token, citySelected?.citySelect));
  };

  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  function addtocart(packageid) {
    setcartisempty(!cartisempty);
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    const token = userFromLocal && userFromLocal.token;
    const body = {
      package: packageid,
    };
    if (token && token !== "") {
      dispatch(AddtoCart(body, token, successCb));
    } else {
      history.push({
        pathname: "/login",
        packageId: packageid,
      });
    }

    toast.success("Item added to cart", {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  useEffect(() => {
    let newArray = [];
    if (props.CartItem && props.CartItem[0] && props.CartItem[0]?.product) {
      props.CartItem[0]?.product.map((item) => {
        newArray.push(item.package.id);
      });
      setItemInCart(newArray);
    }
  }, [props.CartItem]);

  const [cardSlug, setCardSlug] = useState("");
  const [cartData, setCartData] = useState({});
  const [cartClick, setCartClick] = useState(false);
  const [cartId, setCartId] = useState("");

  // const handleCitySubmit = (e) => {
  //   localStorage.setItem("city", e.target.value);
  //   dispatch(setCity(e.target.value));
  //   e.target.blur();
  // };

  const handleBookNow = (card, loc) => {
    // if (citySelect == "" || citySelect == null) {
    //   setOpenCartt(true);
    // } else {
    if (loc && loc == "cart") {
      setCartClick(true);
      setCartId(card.id);
    } else {
      setCartClick(false);
    }
    setCardSlug(card.slug);
    setCartData(card);
    onOpenModal();
  };
  // };

  const closeCartModal = () => {
    setOpenCartt(false);
  };
  // const removetocart = (packageid) => {
  //   const userFromLocal = JSON.parse(localStorage.getItem("user"));
  //   const token = userFromLocal && userFromLocal.token;
  //   dispatch(deleteCart(token, packageid, successCb));

  //   toast.error("Item added to cart", {
  //     position: "bottom-right",
  //     autoClose: 5000,
  //     hideProgressBar: false,
  //     closeOnClick: true,
  //     pauseOnHover: true,
  //     draggable: true,
  //     progress: undefined,
  //   });
  // };

  return loading ? (
    <Loader />
  ) : values && values.length === 0 ? (
    <div className="noPackagefound">
      <h2>No Package Found!!</h2>
    </div>
  ) : (
    <>
      <div className="packageListofOurPacakages">
        {values?.map((card) => {
          var USP = [
            "Lady technician available",
            "Parking Facility",
            "100% Covid Safe",
          ];
          try {
            if (card?.text_criteria && card?.text_criteria != "") {
              var USP = JSON.parse(card?.text_criteria);
            }
          } catch {
            //  var USP = ["Lady technician available","Parking Facility","100% Covid Safe"]
            console.log(USP, card?.name, "<<<<<");
          }
          // console.log("carddddddd", card?.details);
          // console.log("ITEM IN CART ID", ItemInCart);
          return (
            <div
              className={
                card.is_premium
                  ? "Package__card Package__cardNew Package__cardNew2 bgPremium "
                  : "Package__card Package__cardNew Package__cardNew2 bgOrdinary "
              }
              key={card.id}
            >
              <div
                className={
                  card.is_premium
                    ? "packageTopP packageTopHeight"
                    : "packageTopO packageTopHeight"
                }
              >
                {/* <span className={card.is_premium ? "bgGreen" : "bgOrange"}>
                  {card.is_premium ? "Most Popular Plan" : "Heath Check-up"}
                </span> */}

                {/* <div className={card.is_premium ? "pTop" : "oTop"}>
                  <div
                    className="cart_div"
                    onClick={() => handleBookNow(card, "cart")}
                  > */}
                {/* <img src={!cartisempty ? cart_fill : cart_empty} alt="cart icon" /> */}
                {/* {setTimeout(() => {
                      ItemInCart.includes(card?.id) ? (
                        <img src={cart_fill} alt="cart icon" />
                      ) : (
                        <img src={cart_empty} alt="cart icon" />
                      )
                    }, 800)} */}
                {/* {ItemInCart.includes(card?.id) ? (
                      <img src={cart_fill} alt="cart icon" />
                    ) : (
                      <img src={cart_empty} alt="cart icon" />
                    )} */}
                {/* </div>
                </div> */}
                <div className="w-100">
                  <div className="Package__cardTitle Package__cardPadding">
                    <span
                      className={card.is_premium ? "textWhite" : "textBluee "}
                    >
                      <span
                        className={
                          card.is_premium ? "textWhite" : "textBluee txtBlack"
                        }
                      >
                        {card.name.length > 40
                          ? `${card.name.substring(0, 40)}...`
                          : card.name}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              <div className="packageBottom packageBottomNew">
                {/* <div className="Package__cardTitle">
                <span className={card.is_premium ? "textWhite" : "textBlue "}>
                  <Link
                    className={card.is_premium ? "textWhite" : "textBlue "}
                    to={`/${
                      card.slug
                    }-${citySelected.citySelect
                      .toLowerCase()
                      .replace(" ", "-")}`}
                  >
                    {card.name}
                  </Link>
                </span>
              </div> */}
                <div className="Package__cardList Package__cardListNew Package__cardListNewImg Package__cardListNewImg2">
                  <ul>
                    {USP?.map((item) => {
                      return (
                        <li>
                          {" "}
                          <img
                            className="checkIconProductListing"
                            src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/8d216596-4708-4fe9-99bd-a51667e929ac.svg"
                            alt=""
                          />{" "}
                          {item}
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <hr style={{ width: "100%", opacity: "0.3" }} />
                <div className="Package__cardPrice Package__cardPriceNew">
                  {/* <span
                    className={card.is_premium ? "text_Color" : "card__Mrp"}
                  >
                    MRP : &#8377;{" "}
                    {card?.package_city_prices
                      ? card?.package_city_prices?.package_price
                      : card?.package_price}
                  </span>
                  <span
                    className={
                      card.is_premium
                        ? " card__offerPrice  "
                        : "   card__offerPrice textGrey"
                    }
                  >
                    Starts From : &#8377;{" "}
                    {card?.package_city_prices
                      ? card?.package_city_prices?.offer_price
                      : card?.offer_price}
                  </span> */}
                  <span
                    className={
                      card.is_premium
                        ? " card__offerPrice textSizeSmall"
                        : "   card__offerPrice textGrey textSizeSmall"
                    }
                  >
                    Starts from:
                    <div
                      className={
                        card.is_premium
                          ? "newOfferPriceValue premOfferColor"
                          : "newOfferPriceValue"
                      }
                    >
                      &#8377;{" "}
                      {card?.package_city_prices
                        ? card?.package_city_prices?.offer_price
                        : card?.offer_price}{" "}
                      <span
                        className={
                          card.is_premium
                            ? "overlinedPriceNew overlinedPricePrem"
                            : "overlinedPriceNew"
                        }
                      >
                        &#8377;
                        {card?.package_city_prices
                          ? card?.package_city_prices?.package_price
                          : card?.package_price}
                      </span>
                    </div>
                  </span>
                </div>
                <div className="newCardBottom">
                  <div className="Package__BookButton Package__BookButtonNew">
                    <span onClick={() => handleBookNow(card)}>Book Now</span>
                  </div>
                  {/* <div
                    className="cart_div cart_textHeight"
                    onClick={() => handleBookNow(card, "cart")}
                  >
                    <div
                      className={card?.is_premium ? "hover_blue" : "hover_gray"}
                    >
                      {ItemInCart.includes(card?.id) ? (
                        <img
                          className={
                            card?.is_premium
                              ? "cartImageWidth cartImageWidthBlue"
                              : "cartImageWidth"
                          }
                          src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/b6578829-e177-4cbf-953d-837b4b23349d.svg"
                          alt="cart icon"
                        />
                      ) : (
                        <img
                          className={
                            card?.is_premium
                              ? "cartImageWidth cartImageWidthBlue"
                              : "cartImageWidth"
                          }
                          src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/5bb9daa5-5ee2-489c-810d-d7a4dbc9f9aa.svg"
                          alt="cart icon"
                        />
                      )}
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {/* <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customAddressOverlay",
          modal: "customAddressModal",
        }}
      >
        <AddressPopUp
          butname={"SUBMIT"}
          title={"Book Your Test"}
          card={cartData}
          position={"Banner"}
          slug={cardSlug}
          Close={onCloseModal}
          cartId={cartId}
          fromCart={cartClick}
        />
      </Modal> */}

      {open && <FooterForm close={onCloseModal} />}

      <Modal
        open={openCartt}
        onClose={onCloseModalCartt}
        center
        classNames={{
          modal: "selectedCityForPackage",
        }}
      >
        {/*<hr className="topHr" />*/}
        <div className="packageDrop">
          <hr className="topHr" />
          <div className="citySelectHome">
            <form>
              <input
                onClick={() => {
                  setDisplay(true);
                }}
                onFocus={(e) => {
                  e.target.select(), setDisplay(true);
                }}
                style={{ width: "90px" }}
                className="cityDrop_model"
                value={searchCity.replace("_", " ")}
                onChange={(e) => {
                  setSearchCity(e.target.value.replace(" ", "_")),
                    setDisplay(true);
                }}
                placeholder="search city"
              />
            </form>
            {display ? (
              <div className="divCity" defaultValue="Noida">
                <span
                  onFocusCapture={() => {
                    setDisplay(false), setSearchCity(""), handelCity("");
                  }}
                  value=""
                >
                  Select City
                </span>
                {navCity && navCity.navCities && navCity.navCities.cities
                  ? navCity.navCities.cities
                      .filter((city, index) => {
                        if (searchCity == "") {
                          return city;
                        } else if (
                          city.toLowerCase().includes(searchCity.toLowerCase())
                        ) {
                          return city;
                        }
                      })
                      .map((ele, index) => {
                        return (
                          <span
                            onClick={() => handelCity(ele)}
                            key={index}
                            selected={ele == citySelected.citySelect}
                            value={ele}
                          >
                            {ele.replace("_", " ")}
                          </span>
                        );
                      })
                  : " <Loader />"}
              </div>
            ) : null}
          </div>
          <hr className="bottomHr" />
          <div className="cartButtons">
            <button className="closeModal" onClick={() => closeCartModal()}>
              Close
            </button>
          </div>
        </div>
      </Modal>

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ fontSize: "1.8rem" }}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  CartItem: state?.CartReducer?.cartDetails,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(OurImagingPackages));
